import React, { useEffect, useState } from "react";
import { auth, firestore as db } from "../FirebaseConfig";
import { collection, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import {  IoTrashBin } from "react-icons/io5";

export default function CartPage() {
  const [cartItems, setCartItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);


  const handleCheckout = async () => {
    navigate("/checkout");
  };
  
  
  <button
    onClick={handleCheckout}
    className="hidden md:block mt-4 bg-blue-500 text-white px-6 py-2 rounded-md w-full hover:bg-blue-600"
  >
    Proceed to Checkout →
  </button>;



  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId(null);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userId) {
      const fetchCartItems = async () => {
        const cartRef = doc(db, "customers", userId);
        const cartSnap = await getDoc(cartRef);
        if (cartSnap.exists()) {
          setCartItems(cartSnap.data().items || []);
          // setAddress(cartSnap.data().address[cartSnap.data().defaultAddress]);
        }
      };
      fetchCartItems();
    }
  }, [userId]);

  useEffect(() => {
    const fetchProductDetails = async () => {
      const productsCollection = collection(db, "products");
      const productSnapshots = await getDocs(productsCollection);
      const productData = {};
      productSnapshots.forEach((doc) => {
        productData[doc.id] = doc.data();
      });
      setProducts(productData);
    };
    fetchProductDetails();
  }, []);

  const updateQuantity = async (productId, change) => {
    const updatedItems = cartItems.map((item) => {
      if (item.productId !== productId) return item; // Keep other items unchanged
  
      const product = products[item.productId];
      if (!product) return item;
  
      const newQuantity = item.quantity + change;
      if (newQuantity > product.stock) return item; // Prevent exceeding stock limit
  
      return newQuantity > 0 ? { ...item, quantity: newQuantity } : null; // Remove if quantity is 0
    }).filter(Boolean); // Remove null values (products with quantity 0)
  
    setCartItems(updatedItems);
    await updateDoc(doc(db, "customers", userId), { items: updatedItems });
  };
  
  const removeItem = async (productId) => {
    const updatedItems = cartItems.filter((item) => item.productId !== productId);
    setCartItems(updatedItems);
    await updateDoc(doc(db, "customers", userId), { items: updatedItems });
  };

  const subtotal = cartItems.reduce((acc, item) => {
    const product = products[item.productId];
    if (product) {
      const finalPrice = product.prices.productPrice - product.prices.productDiscount;
      return acc + finalPrice * item.quantity;
    }
    return acc;
  }, 0);

  const gstAmount = subtotal - subtotal / 1.05;
  const totalPayable = subtotal;

  return (
    <div className="container mb-25 mx-auto p-4 mt-27">
      <h2 className="text-3xl font-bold mb-6">Shopping Cart - {cartItems.length} items</h2>

      <div className="grid md:grid-cols-3 gap-6">
        {/* Cart Items Section */}
        <div className="md:col-span-2 bg-white p-4 rounded-lg shadow-lg">
          {cartItems.length === 0 ? (
            <div>
               <p className="text-lg text-gray-500 m-10">Your cart is empty.</p>
              <button onClick={() => navigate("/shop")} className="hidden md:block mt-4 bg-blue-500 text-white px-6 py-2 rounded-md w-full hover:bg-blue-600">
           Continue Shopping →
          </button>
           
            </div>
          ) : (
            cartItems.map((item) => {
              const product = products[item.productId];
              if (!product) return null;
              const finalPrice = product.prices.productPrice - product.prices.productDiscount;

              return (
                <div key={item.productId} className="flex items-center border-b py-4">
                  <img src={product.thumbnail} alt={product.name} className="w-40 object-cover rounded-md" />
                  <div className="ml-4 flex-1">
                    <h3 className="text-sm font-semibold">{product.name}</h3>
                    <p className="text-gray-500 text-sm">Category: {product.category}</p>
                    <p className="text-green-600 font-bold">₹{finalPrice}</p>
                    <div className="flex items-center mt-2">
                      <button
                        className="px-2 py-1 border rounded"
                        onClick={() => updateQuantity(item.productId, -1)}
                      >
                        -
                      </button>
                      <span className="mx-2">{item.quantity}</span>
                      <button
                        className={`px-2 py-1 border rounded ${
                          item.quantity >= product.stock ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                        onClick={() => updateQuantity(item.productId, 1)}
                        disabled={item.quantity >= product.stock}
                      >
                        +
                      </button>
                    </div>
                    {item.quantity >= product.stock && (
                      <p className="text-red-500 text-xs mt-1">Only {product.stock} in stock</p>
                    )}
                  </div>
                  <IoTrashBin className="ml-4 h-8 w-40 text-red-500 " onClick={() => removeItem(item.productId)}/>
                 
                </div>
              );
            })
          )}


        </div>

        {/* Summary Section */}
       {cartItems.length !== 0 &&  <div className="bg-white p-4 rounded-lg shadow-lg">
          <h3 className="text-lg font-bold mb-2">Summary</h3>
          <p className="text-gray-700">Products: ₹{subtotal.toFixed(2)}</p>
          <p className="text-gray-700">Inclusive of GST (5%): ₹{gstAmount.toFixed(2)}</p>
          {/* <p className="text-gray-700">Shipping: ₹{deliveryCharge}</p> */}
          <h3 className="text-xl font-bold mt-2">Total: ₹{totalPayable.toFixed(2)}</h3>

          <button onClick={handleCheckout} className="hidden md:block mt-4 bg-blue-500 text-white px-6 py-2 rounded-md w-full hover:bg-blue-600">
            Proceed to  Checkout →
          </button>
        </div>
}
      </div>

      {/* Address Section */}
  
      {/* Floating Bottom Bar for Mobile */}
      {cartItems.length !== 0 &&    <div className="fixed bottom-0 left-0 w-full bg-green-600 text-white p-4 flex justify-between items-center md:hidden">
        <div>
          <p className="text-lg">{cartItems.length} items</p>
          <p className="text-xl font-bold">₹{totalPayable.toFixed(2)}</p>
        </div>
        <button
          onClick={handleCheckout}
          className="bg-white text-green-600 px-6 py-2 rounded-md font-bold"
        >
          Checkout Now →
        </button>
      </div>
}

    </div>
  );
}
